import React from 'react'
import PropTypes from 'prop-types'

const purchaseOrderFormGroup = ({ poNumber, onChange, label = 'Your Internal PO Number', placeholder = '' }) => (
    <div className='col-12 form-group'>
      <label htmlFor='ponumber'>{label}</label>
      <input
        className="form-control"
        name='ponumber'
        id='ponumber'
        type='text'
        placeholder={placeholder}
        onChange={e => onChange(e)}
        value={poNumber}
      />
    </div>
)

purchaseOrderFormGroup.propTypes = {
    poNumber: PropTypes.string,
    onChange: PropTypes.func,
    label: PropTypes.string,
    placeholder: PropTypes.string
}

export default purchaseOrderFormGroup


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/PaymentMethod/PurchaseOrderFormGroup.jsx